import { compareByStringKey } from '@luminovo/commons';
import { useHttpQuery, useSuspenseHttpQuery } from '@luminovo/data-stack';

import { useRfQ } from '../projects/rfqHandler';

export function useCustomers() {
    return useSuspenseHttpQuery(
        'GET /customers',
        {},
        { select: (data) => data.data.sort(compareByStringKey((customer) => customer.name)) },
    );
}

export const useCustomer = (customerId: string | null | undefined) => {
    return useHttpQuery(
        'GET /customers/:customerId',
        { pathParams: { customerId: customerId ?? '' } },
        { select: (data) => data.data, enabled: Boolean(customerId) },
    );
};

export function useCustomerFromRfq(rfqId: string = '') {
    const { data: rfq, isLoading: isRfqLoading } = useRfQ(rfqId, Boolean(rfqId));
    const { data, isLoading } = useCustomer(rfq?.customer);

    // The customer query stays disabled until the project has loaded, and a disabled query reports
    // `isLoading === false`. Without folding the project query in, callers that gate on `isLoading`
    // render before the customer is known and then see it appear a moment later.
    return { data, isLoading: isRfqLoading || isLoading };
}
